<!-- 购物车的详情 -->
<template>
  <div class="home">
    <van-nav-bar
      v-if="isNoOrder"
      fixed
      :title="$t('OrderDetail.subtitle')"
      :style="{ background: sessionStorage.colorCode }"
    >
    </van-nav-bar>
    <van-nav-bar
      v-else
      fixed
      :title="$t('OrderDetail.subtitle')"
      :style="{ background: sessionStorage.colorCode }"
      left-arrow
      @click-left="$router.go(-1)"
    >
    </van-nav-bar>
    <div class="shopTitle">
      <div style="display: flex; align-items: center;">
        <van-icon
          v-if="shopInfos.image"
          :name="shopInfos.image.path"
          size="50px"
        />
        <van-icon v-else name="./static/img/SHOPLOGO.png" size="50px" />
        <span>{{ shopInfos.name }}</span>
      </div>
      <div style="font-size: 16px;font-weight: 600;">
        {{ $t("MealNum.delivery") }}
      </div>
    </div>
    <div class="detail_top">
      <!-- 選擇地址彈框 -->
      <van-popup v-model="showAddress" position="bottom">
        <van-picker
          v-if="!sessionStorage.submitOrder"
          show-toolbar
          :columns="addressSel"
          @cancel="showAddress = false"
          @confirm="omConfirmAddress"
          :confirm-button-text="$t('vantText.confirm')"
          :cancel-button-text="$t('vantText.cancel')"
        />
        <van-picker
          v-else
          show-toolbar
          :columns="addressSel"
          :default-index="`${sessionStorage.additionalIndex}`"
          @cancel="showAddress = false"
          @confirm="omConfirmAddress"
          :confirm-button-text="$t('vantText.confirm')"
          :cancel-button-text="$t('vantText.cancel')"
          readonly
        />
      </van-popup>

      <div class="content">
        <!-- 原外卖流程 -->
        <div v-if="!table_out" class="infoBox">
          <div class="card">
            <div class="title">
              <span
                class="icon_title"
                :style="{ background: sessionStorage.colorCode }"
              ></span
              >{{ $t("InputInfo.infoTitle") }}
            </div>
            <div class="message">
              <span class="required_icon">*</span>{{ $t("InputInfo.required") }}
            </div>
            <!-- 姓名 -->
            <div v-if="nameContro.is_show == 1">
              <van-field
                v-if="nameContro.is_write == 1"
                v-model="name"
                :label="$t('InputInfo.name')"
                clearable
                required
                :rules="[{ message: $t('InputInfo.inputName') }]"
                :placeholder="$t('InputInfo.inputName')"
              />
              <van-field
                v-else
                v-model="name"
                :label="$t('InputInfo.name')"
                clearable
                :placeholder="$t('InputInfo.inputName')"
              />
            </div>
            <!-- 手机 -->
            <div v-if="telContro.is_show == 1">
              <van-field
                v-if="telContro.is_write == 1"
                v-model="phone"
                :label="$t('InputInfo.phone')"
                clearable
                required
                :rules="[{ message: $t('InputInfo.inputPhone') }]"
                :placeholder="$t('InputInfo.inputPhone')"
              />
              <van-field
                v-else
                v-model="phone"
                :label="$t('InputInfo.phone')"
                clearable
                :placeholder="$t('InputInfo.inputPhone')"
              />
            </div>
            <!-- 选择地区 -->
            <van-field
              v-if="showAddressSelect"
              v-model="addressName"
              :label="$t('ContactUs.area')"
              :placeholder="$t('ContactUs.area')"
              readonly
              right-icon="arrow"
              @click="DistrictClick"
            />
            <!-- 地址 -->
            <div v-if="addressContro.is_show == 1">
              <van-field
                v-if="addressContro.is_write == 1"
                v-model="address"
                :label="$t('InputInfo.address')"
                type="textarea"
                rows="1"
                autosize
                clearable
                required
                :rules="[{ message: $t('InputInfo.inputAddress') }]"
                :placeholder="$t('InputInfo.inputAddress')"
              />
              <van-field
                v-else
                v-model="address"
                :label="$t('InputInfo.address')"
                type="textarea"
                rows="1"
                autosize
                clearable
                :placeholder="$t('InputInfo.inputAddress')"
              />
            </div>
            <!-- <van-field
            v-else
            v-model="address"
            :label="$t('InputInfo.address')"
            clearable
            :placeholder="$t('InputInfo.inputAddress')"
          /> -->
            <!-- 交貨日期 -->
            <div v-if="deliveryDateContro.is_show == 1">
              <van-cell-group>
                <van-cell
                  :title="$t('InputInfo.deliveryDate')"
                  :value="deliveryDate"
                >
                  <template #title>
                    <span
                      class="custom-title"
                      v-if="deliveryDateContro.is_show == 1"
                      >{{ $t("InputInfo.deliveryDate") }}</span
                    >
                    <van-button
                      type="danger"
                      class="NowTag"
                      @click="NowDeliveryDate"
                      >NOW</van-button
                    >
                  </template>
                  <template #right-icon>
                    <van-icon
                      name="arrow"
                      class="rightIcon"
                      size="1rem"
                      @click="showDate = true"
                    />
                  </template>
                </van-cell>
                <!-- 日期选择弹出 -->
                <van-popup v-model="showDate" position="bottom">
                  <van-datetime-picker
                    v-model="deliveryDate"
                    type="date"
                    :min-date="minDate"
                    :max-date="maxDate"
                    :confirm-button-text="$t('vantText.confirm')"
                    :cancel-button-text="$t('vantText.cancel')"
                    @cancel="showDate = false"
                    @confirm="confirmDate"
                  />
                </van-popup>
              </van-cell-group>
            </div>
            <!--取餐日期-->
            <div v-if="PickUpDateContro.is_show == 1">
              <van-cell-group>
                <van-cell
                  :title="$t('InputInfo.PickUpDate')"
                  :value="pickUpdate"
                >
                  <template #title>
                    <span
                      class="custom-title"
                      v-if="PickUpDateContro.is_show == 1"
                      >{{ $t("InputInfo.PickUpDate") }}</span
                    >
                    <van-button
                      type="danger"
                      class="NowTag"
                      @click="NowPickUpDate"
                      >NOW</van-button
                    >
                  </template>
                  <template #right-icon>
                    <van-icon
                      name="arrow"
                      class="rightIcon"
                      size="1rem"
                      @click="showDate = true"
                    />
                  </template>
                </van-cell>
                <!-- 日期选择弹出 -->
                <van-popup v-model="showDate" position="bottom">
                  <van-datetime-picker
                    v-model="pickUpdate"
                    type="date"
                    :min-date="minDate"
                    :max-date="maxDate"
                    :confirm-button-text="$t('vantText.confirm')"
                    :cancel-button-text="$t('vantText.cancel')"
                    @cancel="showDate = false"
                    @confirm="confirmPickDate"
                  />
                </van-popup>
              </van-cell-group>
            </div>
            <!-- 交貨時間 -->
            <div v-if="deliveryTimeContro.is_show == 1">
              <van-cell-group>
                <van-cell
                  :title="$t('InputInfo.deliveryTime')"
                  :value="deliveryTime"
                >
                  <template #title>
                    <span
                      class="custom-title"
                      v-if="deliveryTimeContro.is_show == 1"
                      >{{ $t("InputInfo.deliveryTime") }}</span
                    >
                    <van-button
                      type="danger"
                      class="NowTag"
                      @click="NowDeliveryTime"
                      >NOW</van-button
                    >
                  </template>
                  <template #right-icon>
                    <van-icon
                      name="arrow"
                      class="rightIcon"
                      size="1rem"
                      @click="showTime = true"
                    />
                  </template>
                </van-cell>
                <!-- 日期选择弹出 -->
                <van-popup v-model="showTime" position="bottom">
                  <van-datetime-picker
                    v-model="deliveryTime"
                    type="time"
                    :min-hour="0"
                    :max-hour="24"
                    :confirm-button-text="$t('vantText.confirm')"
                    :cancel-button-text="$t('vantText.cancel')"
                    @cancel="showTime = false"
                    @confirm="showTime = false"
                  />
                </van-popup>
              </van-cell-group>
            </div>
            <!--取餐时间-->
            <div v-if="PickUpTimeContro.is_show == 1">
              <van-cell-group>
                <van-cell
                  :title="$t('InputInfo.PickUpTime')"
                  :value="pickUpTime"
                >
                  <template #title>
                    <span
                      class="custom-title"
                      v-if="PickUpTimeContro.is_show == 1"
                      >{{ $t("InputInfo.PickUpTime") }}</span
                    >
                    <van-button
                      type="danger"
                      class="NowTag"
                      @click="NowPickUpTime"
                      >NOW</van-button
                    >
                  </template>
                  <template #right-icon>
                    <van-icon
                      name="arrow"
                      class="rightIcon"
                      size="1rem"
                      @click="showTime = true"
                    />
                  </template>
                </van-cell>
                <!-- 日期选择弹出 -->
                <van-popup v-model="showTime" position="bottom">
                  <van-datetime-picker
                    v-model="pickUpTime"
                    type="time"
                    :min-hour="0"
                    :max-hour="24"
                    :confirm-button-text="$t('vantText.confirm')"
                    :cancel-button-text="$t('vantText.cancel')"
                    @cancel="showTime = false"
                    @confirm="showTime = false"
                  />
                </van-popup>
              </van-cell-group>
            </div>
            <!-- 留言 -->
            <div v-if="commentContro.is_show == 1">
              <van-field
                v-model="comment"
                type="textarea"
                rows="1"
                autosize
                clickable
                clearable
                :label="$t('InputInfo.comment')"
                :required="!!commentContro.is_write"
                :rules="[{ message: $t('InputInfo.inputAddress') }]"
                :placeholder="$t('InputInfo.inputComment')"
              />
            </div>
          </div>
          <!-- 支付凭证 -->
          <van-cell
            :title="$t('InputInfo.paymentVoucher')"
            v-if="isNoOrder && img"
          >
            <template #right-icon>
              <van-image
                width="50"
                fit="contain"
                height="50"
                @click="showImg = true"
                :src="img"
              />
            </template>
          </van-cell>
        </div>

        <!-- 新外卖流程 -->
        <div v-else>
          <van-field
            v-model="name"
            :label="$t('InputInfo.name')"
            clearable
            required
            :rules="[{ message: $t('InputInfo.inputName') }]"
            :placeholder="$t('InputInfo.inputName')"
          />
          <van-field
            v-model="phone"
            :label="$t('InputInfo.phone')"
            clearable
            required
            :rules="[{ message: $t('InputInfo.inputPhone') }]"
            :placeholder="$t('InputInfo.inputPhone')"
          />
          <!-- 支付凭证-->
          <van-cell
            :title="$t('InputInfo.paymentVoucher')"
            v-if="isNoOrder && img"
          >
            <template #right-icon>
              <van-image
                width="50"
                fit="contain"
                height="50"
                @click="showImg = true"
                :src="img"
              />
            </template>
          </van-cell>
        </div>
        <!-- 订单商品列表 -->
        <div class="orderDishes_content">
          <div
            class="orderDishes card"
            v-if="shopCart.data || orderDetail.package"
          >
            <div class="title orderDishe_header">
              <span
                class="icon_title"
                :style="{ background: sessionStorage.colorCode }"
              ></span
              >{{ $t("OrderDetail.title") }}
            </div>
            <template
              v-for="(dish, index) in isNoOrder
                ? orderDetail.package
                : shopCart.data"
            >
              <div class="dishItem" :key="index">
                <div class="dishDetail">
                  <van-image
                    v-if="dish.image"
                    class="menuImg"
                    width="60"
                    height="60"
                    :src="dish.image.path"
                  />
                  <div class="dishDetail_content">
                    <div class="left_content">
                      <div class="dish_name noExceed">{{ dish.menu_name }}</div>
                      <div
                        v-if="dish.category == 'm'"
                        class="dish_des noExceed"
                      >
                        <template v-for="val in dish.tags_name">
                          <template v-for="tags in val">
                            <template v-if="typeof tags == 'object'">
                              <template v-for="tag in tags">
                                {{ tag }}
                              </template>
                            </template>
                            <template v-else>
                              {{ tags }}
                            </template>
                          </template>
                        </template>
                        <template v-for="remark in dish.remark">
                          {{ remark }}
                        </template>
                      </div>
                    </div>
                    <div class="right_content">
                      <div class="dish_price noExceed tr">
                        <span style="font-size: 14px;">{{
                          sessionStorage.getItem("currency")
                        }}</span>
                        {{ dish.price }}
                      </div>
                      <div class="dish_num">x{{ dish.number }}</div>
                    </div>
                  </div>
                </div>
                <template v-for="(son, key) in dish.menus_name">
                  <div class="dishDetail son">
                    <!-- <div class="dish_name noExceed">{{son.menus_name}}</div> -->
                    <div
                      v-if="typeof son == 'object'"
                      class="dish_name noExceed fl"
                    >
                      <template v-for="(menuArr, i) in son"
                        >{{ menuArr
                        }}{{ i == son.length - 1 ? "" : "、" }}</template
                      >
                    </div>
                    <div v-else class="dish_name noExceed fl">{{ son }}</div>

                    <div class="dish_num"></div>
                    <div class="dish_price noExceed"></div>
                    <div class="dish_des noExceed">
                      <template v-if="dish.tags_name[key]">
                        <template v-if="typeof dish.tags_name[key] == 'object'">
                          <template v-for="(tagName, i) in dish.tags_name[key]">
                            <template v-if="typeof tagName == 'object'">
                              {{ arrShow(tagName) }}
                            </template>
                            <template v-else>
                              {{ tagName }}
                            </template>
                            <template v-if="dish.remark[key][i]">
                              ({{ dish.remark[key][i]
                              }}{{
                                i == dish.remark[key].length - 1 ||
                                !dish.remark[key][i]
                                  ? ""
                                  : ""
                              }})
                            </template>
                            &nbsp;&nbsp;
                          </template>
                        </template>
                        <template v-else>
                          {{ dish.tags_name[key] }}
                          <template v-if="dish.remark[key]">
                            ({{ dish.remark[key] }})
                          </template>
                        </template>
                      </template>
                    </div>
                  </div>
                </template>
              </div>
              <div
                style="height: 1px; width: 100%; background-color: #f3f5f7"
              ></div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <!-- 税费列表 -->
    <!-- <div class="tax">
      <van-cell-group v-for="(item, index) in taxsList" :key="index">
        <van-cell v-if="item.status" :title="item.name" :value="item.price" />
      </van-cell-group>
    </div> -->

    <!-- <div style="height: 60px"></div> -->
    <div class="shopBottom">
      <!-- 订单金额 -->
      <div class="orderInfo" v-if="shopCart || orderDetail">
        <div class="infoItem">
          <!-- <div class="info_left">{{ $t("OrderDetail.needPay") }}</div> -->
          <div class="info_left">{{ $t("Dishes.amounts") }}</div>
          <div class="info_right">
            <span class="currency">
              {{ sessionStorage.getItem("currency") }}
            </span>
            {{ isNoOrder ? orderDetail.final_price : shopCart.total }}
          </div>
        </div>
        <!-- <div class="infoItem">
          <div class="info_left">{{ $t("OrderDetail.toPay") }}</div>
          <div class="info_right">
            {{ sessionStorage.getItem("currency")
            }}{{ isNoOrder ? orderDetail.final_price : shopCart.total }}
          </div>
        </div> -->
      </div>
      <div class="functionBox" v-if="isNoOrder">
        <van-button
          class="certainBtn"
          :color="sessionStorage.colorCode"
          round
          @click="payBtn()"
        >
          <!-- {{ $t("OrderDetail.goPay") }} -->
          OK
        </van-button>
      </div>
      <div class="functionBox" v-else>
        <van-button
          class="certainBtn"
          v-if="!table_out"
          round
          @click="$router.go(-1)"
          :style="{ borderColor: sessionStorage.colorCode, background: '#fff' }"
        >
          <!-- {{ $t("OrderDetail.continue") }} -->
          <van-image width="25" height="25" src="./static/img/backCart.png" />
        </van-button>
        <van-button
          class="certainBtn"
          round
          @click="placeOrder()"
          :style="{ background: sessionStorage.colorCode }"
        >
          <!-- {{ $t("OrderDetail.submit") }} -->
          OK
        </van-button>
      </div>
    </div>
    <!-- 付款方式弹窗 - 新版 -->
    <van-popup
      v-model="payWrapper"
      position="bottom"
      :close-on-click-overlay="false"
      round
    >
      <van-nav-bar
        :title="$t('OrderDetail.PaymentMethod')"
        left-arrow
        @click-left="onClickLeft"
      />
      <van-radio-group v-model="radio" @change="onChange">
        <van-cell-group>
          <template v-if="$i18n.locale == 'zh'" v-for="(pay, key) in payMethod">
            <van-cell :title="pay.name_cn" clickable :data-name="pay.name_cn">
              <van-radio
                :checked-color="sessionStorage.colorCode"
                slot="right-icon"
                :name="pay.name_en"
              />
            </van-cell>
          </template>
          <template v-if="$i18n.locale == 'hk'" v-for="(pay, key) in payMethod">
            <van-cell :title="pay.name_hk" clickable :data-name="pay.name_hk">
              <van-radio
                :checked-color="sessionStorage.colorCode"
                slot="right-icon"
                :name="pay.name_en"
              />
            </van-cell>
          </template>
          <template v-if="$i18n.locale == 'en'" v-for="(pay, key) in payMethod">
            <van-cell :title="pay.name_en" clickable :data-name="pay.name_en">
              <van-radio
                :checked-color="sessionStorage.colorCode"
                slot="right-icon"
                :name="pay.name_en"
              />
            </van-cell>
          </template>
        </van-cell-group>
        <div style="width: 50%; height: 50px; margin: 0 auto;}">
          <van-button
            style="
              width: 90%;
              height: 35px;
              margin-left: 5%;
              margin-top: 7px;
              line-height: 35px;
            "
            :color="sessionStorage.colorCode"
            round
            @click="goPay()"
          >
            <!-- {{ $t("OrderDetail.goPay") }} -->OK
          </van-button>
        </div>
      </van-radio-group>
    </van-popup>
    <!-- 上传凭证 -->
    <van-dialog
      v-model="isVoucher"
      :title="$t('OrderDetail.uploadVoucher')"
      :confirmButtonText="$t('OrderDetail.confirm')"
      closeOnClickOverlay
      @confirm="uploaderVoucher"
    >
      <van-uploader
        v-model="fileList"
        :max-count="1"
        :before-delete="beforeDelete"
        :after-read="afterRead"
      />
      <div>
        <p>{{ $t("OrderDetail.accountInformation") }}</p>
        <p class="info"></p>
      </div>
    </van-dialog>
    <!-- 點擊憑證圖片彈出 -->
    <van-popup v-model="showImg" v-if="img">
      <van-image fit="contain" :src="img" />
    </van-popup>
    <div class="form" v-html="content"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showDate: false,
      showTime: false,
      isNoOrder: false,
      payWrapper: false,
      showAddressSelect: false,
      showAddress: false,
      table_out: false, //是否是新外卖流程
      is_additional: false,
      isVoucher: false, //是否上传凭证
      showImg: false,
      ShowCounter: false,
      minDate: "",
      maxDate: "",
      order: "",
      radio: "",
      name: "",
      phone: "",
      address: "",
      comment: "",
      deliveryTime: "",
      deliveryDate: "",
      pickUpdate: "",
      pickUpTime: "",
      additional_id: "",
      addressName: "",
      file: "",
      img: "",
      content: "",
      orderDetail: {},
      shopCart: {},
      nameContro: {},
      telContro: {},
      addressContro: {},
      commentContro: {},
      deliveryTimeContro: {},
      deliveryDateContro: {},
      PickUpTimeContro: {},
      PickUpDateContro: {},
      payMethod: [],
      addressList: [],
      addressSel: [],
      deliveries: [],
      fileList: [],
      shopInfos: []
    };
  },
  computed: {
    priceTotal() {
      return function(arr) {
        var sum = 0;
        for (var i in arr) {
          sum += Number(arr[i]);
        }
        console.log(sum);
        return sum;
      };
    },
    arrShow() {
      return function(arr) {
        var str = "";
        for (var i in arr) {
          str += arr[i] + (i == arr.length - 1 || !arr[i] ? "" : ",");
        }
        return str;
      };
    }
  },
  created() {
    // 判断外卖类型
    if (
      localStorage.onlyCode == localStorage.successCode &&
      localStorage.takeOrderId !== undefined
    ) {
      this.isNoOrder = true;
      this.getOrderDetail();
    } else {
      this.isNoOrder = false;
      this.getShopCart();
    }
    this.getPayment();
    if (
      sessionStorage.is_additional == "1" ||
      sessionStorage.is_additional == 1
    ) {
      this.getShopInfo();
    }
    this.getShopInfo();
  },
  mounted() {
    this.minDate = new Date(Date.now());
    let date = Date.now() + 86400 * 1000 * 365;
    this.maxDate = new Date(date);

    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    });
    console.log(sessionStorage);
    // 点击提交订单后再返回订单时的回显
    this.addressName = sessionStorage.additional;
    this.shopInfos = JSON.parse(sessionStorage.shopInfos);
  },
  beforeUpdate() {
    if (sessionStorage.additionalIndex) {
      this.Address(sessionStorage.additionalIndex);
    }
  },
  methods: {
    onClickLeft() {
      this.payWrapper = false;
    },
    chearBtn() {
      this.comment = "";
    },
    // 確認提交信息
    uploaderVoucher() {
      if (this.file) {
        let formData = new FormData();
        formData.append("order_id", localStorage.takeOrderId);
        formData.append("file", this.file.file);
        this.formData = formData;
        this.$axios({
          method: "post",
          url: this.$build + "/api/order/upload",
          data: formData
        })
          .then(res => {
            console.log("上傳成功", res);
            if (res.data.status == 200) {
              this.$toast({
                type: "loading",
                forbidClick: true,
                loadingType: "spinner"
              });
              let _this = this;
              setTimeout(function() {
                _this.$router.push("/TakeCashPayment");
              }, 2000);

              // this.img = res.data.data.certificates[0].image.path;
            } else {
              this.fileList = [];
              this.$toast.allowMultiple();
              for (var item in res.data.error) {
                this.$toast({
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            this.$toast({
              type: "fail",
              message: this.$t("OrderDetail.message")
            });
          });
      } else {
        this.$toast({
          type: "fail",
          message: this.$t("OrderDetail.voucherTip")
        });
      }
    },
    beforeDelete() {
      console.log("清空file");
      this.file = "";
      this.fileList.pop();
    },
    // 上传图片
    afterRead(file) {
      console.log("圖片信息", file);
      this.file = file;
    },
    //获取店铺信息
    getShopInfo() {
      this.$axios({
        method: "get",
        headers: {
          code: this.$route.params.code
        },
        url:
          this.$build + "/api/store/" + sessionStorage.storeId + "/customerShow"
      })
        .then(res => {
          console.log("获取店铺设定", res.data.data);
          console.log("收货信息设定", res.data.data.deliveries);
          if (res.data.status == 200) {
            // 打印设置
            this.deliveries = res.data.data.deliveries;
            // 地区
            let additional_charge = Number(res.data.data.additional_charge);
            let total = Number(this.shopCart.total);
            this.addressList = res.data.data.additionals;
            this.is_additional =
              res.data.data.is_additional == "0" ? false : true;
            if (this.is_additional) {
              if (this.addressList) {
                // 地区附加费列表
                this.addressSel = [];
                console.log(total, additional_charge);
                if (additional_charge <= total) {
                  this.addressList.forEach(d => {
                    if (d.status == 1) {
                      this.addressSel.push(d.name + "(" + d.price + ")");
                    } else {
                      this.addressSel.push(d.name + " (00.00)");
                    }
                  });
                } else {
                  this.addressList.forEach(d => {
                    this.addressSel.push(d.name + "(" + d.price + ")");
                  });
                }
                this.showAddressSelect = true;
              }
            }
            this.deliveries.forEach(d => {
              if (d.type == 1) {
                this.nameContro = d;
              } else if (d.type == 2) {
                this.telContro = d;
              } else if (d.type == 3) {
                this.addressContro = d;
              } else if (d.type == 4) {
                this.PickUpDateContro = d;
              } else if (d.type == 5) {
                this.PickUpTimeContro = d;
              } else if (d.type == 6) {
                this.deliveryDateContro = d;
              } else if (d.type == 7) {
                this.deliveryTimeContro = d;
              } else if (d.type == 8) {
                this.commentContro = d;
              }
            });
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 选择地区
    omConfirmAddress(value, index) {
      console.log("選中的地址", value, index);
      // 判斷是否點擊了支付，是否回顯
      sessionStorage.setItem("additional", value);
      sessionStorage.setItem("additionalIndex", index);
      // ??????????????????????????????????????????????/
      let price = this.addressSel[index];
      if (price.indexOf("(00.00)") == -1) {
        if (this.shopCart.data) {
          this.Address(index);
        }
        this.showAddress = false;
        this.additional_id = this.addressList[index].id;
        this.addressName = value;
      } else {
        this.showAddress = false;
        this.additional_id = this.addressList[index].id;
        this.addressName = value;
        let price = 0;
        this.shopCart.data.forEach(j => {
          price += j.price;
        });
        this.shopCart.total = price + ".00";
      }
    },
    // 获取加了地区附加费的订单金额
    Address(index) {
      console.log(this.shopCart);
      this.$axios({
        method: "post",
        url: this.$build + "/api/place/confirmShopcart",
        data: {
          code: this.shopCart.data[0].code,
          additional_id: this.addressList[index].id
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.shopCart.total = res.data.total;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                duration: 1000,
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            duration: 1000,
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 获取订单详情
    getOrderDetail() {
      this.$axios({
        method: "PUT",
        url:
          this.$build + "/api/order/" + localStorage.takeOrderId + "/takeIndex"
      })
        .then(res => {
          if (res.data.status == 200) {
            console.log("訂單信息", res);
            this.orderDetail = res.data.data;
            if (res.data.data.certificates[0]) {
              this.img = res.data.data.certificates[0].image.path;
            }
            this.name = res.data.data.order_address.name;
            this.phone = res.data.data.order_address.phone;
            this.address = res.data.data.order_address.address;
            this.comment = res.data.data.order_address.comment;
            this.deliveryTime = res.data.data.order_address.time;
            this.deliveryDate = res.data.data.order_address.date;
            this.pickUpdate = res.data.data.order_address.pick_date;
            this.pickUpTime = res.data.data.order_address.pick_time;
            localStorage.setItem("takeOrderNo", res.data.data.order);
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
          this.getCode();
        });
    },
    getCode() {
      this.$axios({
        method: "get",
        url: this.$build + "/api/shopcart/create"
      })
        .then(res => {
          //   console.log(res);
          if (res.data.status == 200) {
            localStorage.setItem("onlyCode", res.data.code);
            this.$router.push("/TakeDishes");
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 获取购物车
    getShopCart() {
      this.$axios({
        method: "post",
        url: this.$build + "/api/place/takeShopcart",
        data: {
          code: localStorage.getItem("onlyCode")
        }
      })
        .then(res => {
          console.log("獲取購物車", res);
          if (res.data.status == 200) {
            this.shopCart = res.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                duration: 1000,
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            duration: 1000,
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 去提交订单
    placeOrder() {
      console.log("提交订单");
      if (this.table_out) {
        console.log("新外卖流程");
        // 新外卖流程
        if (!this.name) {
          this.$toast(this.$t("InputInfo.inputName"));
        } else if (!this.phone) {
          this.$toast(this.$t("InputInfo.inputPhone"));
        } else {
          if (this.payMethod.length > 0) {
            this.payBtn();
            this.$axios({
              method: "PATCH",
              url: this.$build + "/api/place/takeOrder",
              data: {
                code: localStorage.onlyCode,
                store_id: sessionStorage.storeId,
                type: "2", //类型：【1：打包，2：外卖】
                name: this.name,
                // area_code:this.areacode,
                phone: this.phone,
                additional_id: this.additional_id,
                address: this.address
              }
            })
              .then(res => {
                console.log(res);
                if (res.data.status == 200) {
                  this.$toast({
                    type: "success",
                    message: res.data.message
                  });
                  this.order = res.data.order;
                  localStorage.setItem("takeOrderId", res.data.id);
                  localStorage.setItem("takeOrderNo", res.data.order);
                  localStorage.setItem("successCode", localStorage.onlyCode);
                  // localStorage.setItem('hasOrder',1);
                  var vm = this;
                  setTimeout(() => {
                    vm.payBtn();
                  }, 500);
                } else {
                  for (var item in res.data.error) {
                    this.$toast({
                      type: "fail",
                      message: res.data.error[item]
                    });
                  }
                }
              })
              .catch(err => {
                this.$toast({
                  type: "fail",
                  message: this.$t("common.message")
                });
              });
          } else {
            this.$toast("没有设置支付方式");
          }
        }
      } else {
        // 原外卖流程
        console.log("原外卖流程");
        if (
          this.nameContro.is_write == 1 &&
          this.nameContro.is_show == 1 &&
          !this.name
        ) {
          this.$toast(this.$t("InputInfo.inputName"));
        } else if (
          this.telContro.is_write == 1 &&
          this.telContro.is_show == 1 &&
          !this.phone
        ) {
          this.$toast(this.$t("InputInfo.inputPhone"));
        } else if (
          this.addressContro.is_write == 1 &&
          this.addressContro.is_show == 1 &&
          !this.address
        ) {
          this.$toast(this.$t("InputInfo.inputAddress"));
        } else if (
          this.commentContro.is_write == 1 &&
          this.commentContro.is_show == 1 &&
          !this.comment
        ) {
          this.$toast(this.$t("InputInfo.inputComment"));
        } else if (
          this.deliveryTimeContro.is_write == 1 &&
          this.deliveryTimeContro.is_show == 1 &&
          !this.deliveryTime
        ) {
          this.$toast(this.$t("InputInfo.inputDeliveryTime"));
        } else if (
          this.deliveryDateContro.is_write == 1 &&
          this.deliveryDateContro.is_show == 1 &&
          !this.deliveryDate
        ) {
          this.$toast(this.$t("InputInfo.inputDeliveryDate"));
        } else {
          if (this.payMethod.length > 0) {
            this.payBtn();
            this.$axios({
              method: "PATCH",
              url: this.$build + "/api/place/takeOrder",
              data: {
                code: localStorage.onlyCode,
                store_id: sessionStorage.storeId,
                type: "2", //类型：【1：打包，2：外卖】
                name: this.name,
                // area_code:this.areacode,
                phone: this.phone,
                additional_id: this.additional_id,
                address: this.address,
                date: this.deliveryDate,
                time: this.deliveryTime,
                pick_date: this.pickUpdate,
                pick_time: this.pickUpTime,
                comment: this.comment
              }
            })
              .then(res => {
                console.log(res);
                if (res.data.status == 200) {
                  this.$toast({
                    type: "success",
                    message: res.data.message
                  });
                  localStorage.setItem("takeOrderId", res.data.id);
                  localStorage.setItem("takeOrderNo", res.data.order);
                  localStorage.setItem("successCode", localStorage.onlyCode);
                  // localStorage.setItem('hasOrder',1);
                  var vm = this;
                  setTimeout(() => {
                    vm.payBtn();
                  }, 500);
                } else {
                  for (var item in res.data.error) {
                    this.$toast({
                      type: "fail",
                      message: res.data.error[item]
                    });
                  }
                }
              })
              .catch(err => {
                this.$toast({
                  type: "fail",
                  message: this.$t("common.message")
                });
              });
          } else {
            this.$toast("没有设置支付方式");
          }
        }
      }
    },
    // 获取可用支付方式
    getPayment() {
      this.$axios({
        method: "GET",
        headers: {
          type: sessionStorage.type,
          code: sessionStorage.code,
          placeid: sessionStorage.placeId
        },
        url:
          this.$build + "/api/store/" + sessionStorage.storeId + "/customerShow"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            if (res.data.data.outsite.length > 0) {
              this.payMethod = res.data.data.outsite;
              this.radio = res.data.data.outsite[0].name_en;
            } else {
              this.payMethod = [];
              this.radio = "";
            }
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    onChange(val) {
      console.log(val);
    },
    payBtn() {
      if (this.payMethod.length > 0) {
        if (sessionStorage.submitOrder) {
          this.$router.push("/TakeCashPayment");
        } else {
          this.payWrapper = true;
        }
      } else {
        this.$toast({
          type: "fail",
          message: "没有设置支付方式"
        });
      }
    },
    // 选择支付方式去支付
    goPay() {
      localStorage.setItem("orderLineType", "takeAway");
      // 是否點擊了支付
      sessionStorage.setItem("submitOrder", 1);
      if (this.radio == "Paypal") {
        console.log("Paypal支付");
        this.pay();
      } else if (this.radio == "Cash") {
        console.log("现金支付");
        this.$router.push("/TakeCashPayment");
      } else if (this.radio == "WeChat Pay") {
        console.log("微信支付");
        this.wxpay();
      } else if (this.radio == "Alipay") {
        console.log("支付宝支付");
        this.Alipay();
      } else if (this.radio == "ECpay" || this.radio == "EC Pay") {
        console.log("ECpay支付");
        this.ECpay();
      } else if (this.radio == "Apple Pay") {
        console.log("Apple支付");
      } else if (this.radio == "Credit Card") {
        console.log("信用卡支付");
      } else if (this.radio == "Line Pay") {
        console.log("LinePay支付");
        this.linepay();
      } else if (this.radio == "Apple pay") {
        console.log("ApplePay支付");
        this.Applepay();
      } else if (this.radio == "Google pay") {
        console.log("GooglePay支付");
        this.googlepay();
      } else if (this.radio == "八达通") {
        console.log("八达通支付");
        this.badatong();
      } else if (this.radio == "Voucher Payment") {
        console.log("Voucher Payment支付");
        this.isVoucher = true;
        this.VoucherPay();
      }
    },
    // 憑證支付
    VoucherPay() {},
    // paypal支付
    pay() {
      this.$toast.loading({
        message: this.$t("OrderDetail.loading"),
        forbidClick: true
      });
      this.$axios({
        method: "post",
        url: this.$build + "/api/paypal/pay",
        data: {
          order: localStorage.takeOrderNo,
          code: localStorage.onlyCode
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            console.log(res);
            window.location.href = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
          this.$toast.clear();
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // mypal支付
    mypay() {
      this.$toast.loading({
        message: this.$t("OrderDetail.loading"),
        forbidClick: true
      });
      this.$axios({
        method: "post",
        url: this.$build + "/api/mypays/pay",
        data: {
          order: localStorage.takeOrderNo,
          code: localStorage.onlyCode
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            console.log(res);
            window.location.href = res.data.data.url;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
          this.$toast.clear();
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // linepay 支付
    linepay() {
      this.$toast.loading({
        message: this.$t("OrderDetail.loading"),
        forbidClick: true
      });
      this.$axios({
        method: "post",
        url: this.$build + "/api/line-pay/pay",
        data: {
          order: localStorage.getItem("takeOrderNo")
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            if (res.data.data.info) {
              setTimeout(() => {
                window.location.href = res.data.data.info.paymentUrl.web;
              }, 800);
            } else {
              this.$toast({
                type: "success",
                message: res.data.data.returnMessage
              });
            }
          } else {
            for (var item in res.data.error.message) {
              this.$toast({
                type: "fail",
                message: res.data.error.message[item]
              });
            }
          }
          this.$toast.clear();
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 微信支付
    wxpay() {
      this.$toast.loading({
        message: this.$t("OrderDetail.loading"),
        forbidClick: true
      });
      this.$axios({
        method: "post",
        url: this.$build + "/api/wechat/pay",
        data: {
          order: localStorage.getItem("takeOrderNo")
        }
      })
        .then(res => {
          console.log(res.data);
          if (res.status == 200) {
            this.$toast({
              type: "loading",
              message: ""
            });
            var s = res.data.replace(/<script>window.location.href="/, "");
            console.log(s);
            var c2 = s.substr(0, s.length - 10);
            console.log(c2);
            window.location.href = `${c2}`;
            this.$axios({
              method: "post",
              url: this.$build + "/api/wechat/notify",
              data: null
            })
              .then(res => {
                console.log(res);
                if (res.data.status == 200) {
                  console.log(res.data);
                  this.$toast({
                    type: "success",
                    message: res.data.data.returnMessage
                  });
                } else {
                  for (var item in res.data.error.message) {
                    this.$toast({
                      type: "fail",
                      message: res.data.error.message[item]
                    });
                  }
                }
              })
              .catch(err => {
                this.$toast({
                  type: "fail",
                  message: this.$t("common.message")
                });
              });
          } else {
            for (var item in res.data.error.message) {
              this.$toast({
                type: "fail",
                message: res.data.error.message[item]
              });
            }
          }
          this.$toast.clear();
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 支付宝支付
    Alipay() {
      this.$axios({
        method: "post",
        url: this.$build + "/api/alipay/pay",
        data: {
          order: localStorage.getItem("takeOrderNo")
        }
      })
        .then(res => {
          console.log(res.data);
          this.content = res.data;
          this.$toast({
            type: "loading",
            message: ""
          });
          setTimeout(() => {
            document.forms[0].submit(); //通过submit()传递给服务器，进行响应
            this.$axios({
              method: "post",
              url: this.$build + "/api/alipay/notify",
              data: null
            })
              .then(res => {
                console.log(res);
                if (res.data.status == 200) {
                  console.log(res.data);
                  this.$toast({
                    type: "success",
                    message: res.data.data.returnMessage
                  });
                } else {
                  for (var item in res.data.error.message) {
                    this.$toast({
                      type: "fail",
                      message: res.data.error.message[item]
                    });
                  }
                }
              })
              .catch(err => {
                this.$toast({
                  type: "fail",
                  message: this.$t("common.message")
                });
              });
          }, 100);
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // ECpay支付
    ECpay() {
      this.$axios({
        method: "post",
        url: this.$build + "/api/ec-pay/pay",
        data: {
          order: localStorage.getItem("takeOrderNo")
        }
      }).then(res => {
        console.log(res);
        this.$toast({
          type: "loading",
          message: ""
        });
        window.location.href = res.data.data.url;
      });
    },
    // Apple Pay支付
    Applepay() {},
    // Google Pay支付
    googlepay() {},
    // 八达通支付
    badatong() {},
    // 时间格式化 2019-09-08
    timeFormat(time) {
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      if (Number(month) < 10) {
        if (Number(day) < 10) {
          return year + "-0" + month + "-0" + day;
        } else {
          return year + "-0" + month + "-" + day;
        }
      } else {
        if (Number(day) < 10) {
          return year + "-" + month + "-0" + day;
        } else {
          return year + "-" + month + "-" + day;
        }
        // return year + "-" + month + "-" + day;
      }
    },
    // 点击地区按钮时更新店铺数据和控制地区附加费显示和隐藏
    DistrictClick() {
      this.showAddress = true;
      this.getShopInfo();
    },
    // 选择交货时间
    confirmTime(e) {
      this.showTime = false;
    },
    confirmDate(e) {
      this.deliveryDate = this.timeFormat(e);
      this.showDate = false;
    },
    confirmPickDate(e) {
      this.pickUpdate = this.timeFormat(e);
      this.showDate = false;
    },
    CounterCheckout() {
      this.$router.push("/TakeCashPayment");
    },
    // 现在交货日期
    NowDeliveryDate() {
      let myDate = new Date();
      this.deliveryDate = myDate.toLocaleDateString();
    },
    // 现在交货时间
    NowDeliveryTime() {
      let myDate = new Date();
      let Minutes = myDate.getMinutes();
      if (Minutes < 10) {
        this.deliveryTime = myDate.getHours() + ":0" + myDate.getMinutes();
      } else {
        this.deliveryTime = myDate.getHours() + ":" + myDate.getMinutes();
      }
    },
    // 现在交货日期
    NowPickUpDate() {
      let myDate = new Date();
      this.pickUpdate = myDate.toLocaleDateString();
    },
    // 现在取餐时间
    NowPickUpTime() {
      let myDate = new Date();
      let Minutes = myDate.getMinutes();
      if (Minutes < 10) {
        this.pickUpTime = myDate.getHours() + ":0" + myDate.getMinutes();
      } else {
        this.pickUpTime = myDate.getHours() + ":" + myDate.getMinutes();
      }
    }
  }
};
</script>
<style scoped>
/deep/ .van-field__control {
  text-align: right;
}
/deep/ .van-image {
  vertical-align: middle;
  max-width: 600px;
  max-height: 600px;
}
.info {
  margin: 0 auto;
  width: 300px;
  text-align: left;
}
/deep/ .van-dialog {
  width: 400px;
}
/deep/ .van-uploader__upload {
  width: 250px;
  height: 200px;
}
/deep/ .van-uploader__preview-image {
  width: 250px;
  height: 250px;
}
/deep/ .van-dialog__content {
  text-align: center;
  padding: 20px 0;
}
/deep/ .van-nav-bar {
  z-index: 999;
}
/deep/ .van-nav-bar .van-icon {
  font-size: 26px;
  color: #fff;
}
/deep/ .van-field__body > input {
  text-align: right;
}
/deep/ .van-toast__text {
  font-size: 0.75rem;
}
.okIcon {
  vertical-align: middle;
}
/deep/ .van-image {
  border-radius: 5px;
  overflow: hidden;
}
/deep/ .van-cell__title {
  display: flex;
  align-items: center;
}
/deep/ .van-popup .van-nav-bar .van-icon {
  color: #000;
}
/deep/ .van-popup .van-nav-bar__title {
  color: #000 !important;
}
/deep/ .van-field__label {
  color: #000;
}
/deep/ .infoBox .van-cell__title {
  color: #000;
}
.home {
  width: 100%;
  height: 100%;
  background-color: #bbbbbb;
}
.content {
  height: 100%;
  overflow: auto;
}
.shopTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 56px 15px 10px;
  background-color: #fff;
  position: fixed;
  width: calc(100% - 30px);
  z-index: 99;
}
.shopTitle span {
  margin-left: 10px;
  font-size: 18px;
  font-weight: 600;
}
.infoBox {
  padding: 5px 10px;
  background-color: #bbbbbb;
}
.detail_top {
  width: 100%;
  height: calc(100% - 116px);
  padding-top: 116px;
  margin-bottom: 10px;
}
.top_success {
  width: auto;
  height: 40px;
  line-height: 40px;
  padding-right: 10px;
}
.top_sit {
  height: 35px;
  line-height: 35px;
  font-size: 18px;
  padding-left: 10px;
}
.top_price {
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-weight: bold;
  font-size: 22px;
  margin-top: 5px;
}
.dishDetail {
  display: flex;
  margin-bottom: 10px;
}
.dishDetail_content {
  width: calc(100% - 70px);
  display: flex;
  margin-left: 10px;
}
.left_content,
.right_content {
  width: 50%;
}
.dishDetail .price {
  text-align: left;
  color: #999;
}
.orderDishes_content {
  padding: 0px 10px;
  padding-bottom: 120px;
}
.orderDishes {
  margin: 0px 5px;
  min-height: 50px;
}
.dish_name {
  width: 60%;
  height: 35px;
  line-height: 35px;
  float: left;
}
.dish_num {
  color: #999;
  font-size: 14px;
  text-align: right;
}
.dish_price {
  /* width: 25%; */
  font-size: 18px;
  height: 35px;
  line-height: 35px;
  color: #000;
  text-align: right;
  /* float: left; */
}
.dishDetail .price {
  text-align: right;
  color: #000;
}
.dish_des {
  width: 100%;
  height: 20px;
  color: #999;
  clear: both;
  font-size: 14px;
}
.leftdot {
  position: absolute;
  width: 6px;
  height: 6px;
  left: -3.5%;
  top: 15px;
  background: linear-gradient(90deg, #ffc914, #ffc813);
  border-radius: 50%;
}
.totalPrice {
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  text-align: right;
}
.son > div {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.cancelBtn {
  width: 30%;
  top: 8px;
  left: 5%;
  background: #2f75f4;
  color: #fff;
  font-weight: bold;
  font-size: 16px;
}
@media screen and (min-width: 800px) {
  .shopBottom {
    width: 800px;
  }
}
@media screen and (max-width: 800px) {
  .shopBottom {
    width: 100%;
  }
}
.shopBottom {
  position: fixed;
  bottom: 0;
  background: #fff;
  /* height: 60px; */
  /* display: flex;
  justify-content: space-between;
  border-top: 1px solid #ccc; */
}
.functionBox {
  height: 60px;
  display: flex;
  justify-content: space-between;
  box-shadow: 0px 0px 10px #979797;
}
.certainBtn {
  top: 8px;
  width: 40%;
  background: #2f75f4;
  color: #fff;
  font-weight: bold;
  font-size: 16px;
  margin: 0 auto;
}
.orderInfo {
  /* width: 90%;
  margin-left: 5%;
  height: 60px;
  padding-top: 5px; */
  padding: 10px 20px 5px;
}
.infoItem {
  width: 100%;
  height: 25px;
  font-size: 14px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
}
.info_left {
  flex: auto;
  text-align: left;
  height: 25px;
  line-height: 25px;
  font-size: 18px;
  font-weight: 600;
  color: #000;
}
.info_right {
  flex: auto;
  text-align: right;
  height: 25px;
  line-height: 25px;
  color: #fe0000;
  font-size: 24px;
  font-weight: 600;
}
.currency {
  font-size: 18px;
}
.menuIconGroup {
  height: 35px;
}
.type_icon {
  width: 50%;
  height: 35px;
  line-height: 35px;
  float: left;
  display: flex;
  display: -webkit-flex;
  align-items: center;
}
.type_icon > span {
  font-size: 14px;
  text-indent: 10px;
}
.row1 {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
}
.Counter p {
  font-size: 1.125rem;
}
.rightIcon {
  line-height: 1.5rem;
}
.NowTag {
  height: auto;
  padding: 2px 5px;
  margin-left: 10px;
  border-radius: 10px;
  background-color: #fe0000;
}
.card {
  background: #fff;
  margin: 5px;
  padding: 10px;
  box-shadow: 0px 0px 10px #979797;
  border-radius: 15px;
}
.title {
  display: flex;
  align-items: center;
  color: #000;
  font-weight: 600;
}
.icon_title {
  display: inline-block;
  width: 7px;
  height: 16px;
  border-radius: 10px;
  margin-right: 5px;
}
.required_icon {
  color: #fe0000;
  font-size: 22px;
  font-weight: 600;
  position: relative;
  top: 7px;
  margin-right: 5px;
}
.message {
  padding-bottom: 10px;
  font-size: 14px;
  color: #a0a0a0;
  border-bottom: 2px solid #e5e5e5;
}
.orderDishe_header {
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 2px solid #e5e5e5;
}
</style>



// WEBPACK FOOTER //
// src/takeAway/TakeCartDetail.vue